import type { ScheduleGroup } from '../types/schedule-groups';
import type { School } from '../types/schools';
import type { OutTypes } from './schedules';


export default function (
  scheduledGroups: ScheduleGroup[] | undefined,
  school:          School,
  importErrors:    string[],
  importWarnings:  string[],
): OutTypes.course[] {

  const courses: OutTypes.course[] = [];

  scheduledGroups?.forEach(scheduledGroup => {

    ////
    //// check number of subjects/courses
    ////
    const subjects = school.school_type == 'GR' ? scheduledGroup.subjects : scheduledGroup.courses;
    if (subjects.length != 1) {
      const warn = `The schedule group "${scheduledGroup.name}" with id "${scheduledGroup.id}" contained ${subjects.length} number of ${school.school_type == 'GR' ? 'subjects' : 'courses'} and was therefore omitted: a schedule group shall contain only a single ${school.school_type == 'GR' ? 'subject' : 'course'}.`;
      importWarnings.push(warn);
      return;
    }


    ////
    //// check number of teachers
    ////
    if (scheduledGroup.teachers?.length == 0) {
      const warn = `The schedule group "${scheduledGroup.name}" with id "${scheduledGroup.id}" did not contain any teachers.`;
      importWarnings.push(warn);
    }


    courses.push({
      ids:         scheduledGroup.id.toString(),
      displayName: scheduledGroup.name,
      subject:     subjects.map(x => x.name).join(', '),
      groups:      scheduledGroup.users_primary_groups.map(x => ({ to: x.toString() })),
      teachers:    scheduledGroup.teachers?.map(x => ({ to: x.id.toString() }))
    } satisfies OutTypes.course);

  });

  return courses;
}
